import type {User} from '../../auth/types';
import {getCrmViews} from './crmViews';

export const SEARCH_DEPARTMENTS = ['manager','reception','sales','hr','accountant','marketing'] as const;
export type SearchDepartment = typeof SEARCH_DEPARTMENTS[number];
export const searchDepartmentLabels:Record<SearchDepartment,[string,string]> = {
  manager:['Management','الإدارة'],reception:['Reception','الاستقبال'],sales:['Sales','المبيعات'],
  hr:['HR','الموارد البشرية'],accountant:['Accountant','الحسابات'],marketing:['Marketing','التسويق'],
};
export function currentSearchDepartment(path:string):SearchDepartment|undefined {
  const segment=path.replace(/^\/app(?=\/)/,'').split('/')[1];
  return SEARCH_DEPARTMENTS.find(department=>department===segment);
}
/** Presentation availability only. Every provider retains its backend guard. */
export function allowedSearchDepartments(user:User):SearchDepartment[] {
  const views=getCrmViews(user);
  return SEARCH_DEPARTMENTS.filter(department=>views.some(view=>view.id===department));
}

/** Functional ownership, not endpoint location. Management has native students,
 * groups and employees routes in AppShells. Specialized Sales, Marketing and
 * Accountant documents remain reachable through All Departments, with guards.
 * Mapping management financial reports to these document types needs owner review.
 */
export const currentSearchEntityKinds:Record<SearchDepartment,readonly string[]>={
  manager:['student','group','employee'],reception:['student','group'],sales:['lead','customer'],
  hr:['employee'],marketing:['course'],accountant:['invoice','receipt','refund','expense','placement_payment','income'],
};
